import axiosInstance from './axios-instance';
import { FormHelper } from '../../utils/helpers/form.helper';

class ApiClient {
    static buildVersionedEndpoint(endpoint, version = 'v1') {
        return `/${version}${endpoint}`;
    }

    static async get(endpoint, queryParams = {}, config = {}, version = 'v1') {
        return axiosInstance.get(this.buildVersionedEndpoint(endpoint, version), {
            params: queryParams,
            ...config
        });
    }

    static post(endpoint, body = {}, queryParams = {}, config = {}, version = 'v1') {
        return axiosInstance.post(this.buildVersionedEndpoint(endpoint, version), body, {
            params: queryParams,
            ...config
        });
    }

    static async postFormData(endpoint, body, queryParams = {}, version = 'v1') {
        return axiosInstance.post(this.buildVersionedEndpoint(endpoint, version), body, {
            params: queryParams
        });
    }

    static async put(endpoint, body, queryParams = {}, version = 'v1') {
        return axiosInstance.put(this.buildVersionedEndpoint(endpoint, version), body, {
            params: queryParams
        });
    }

    static async patch(endpoint, body, queryParams = {}, version = 'v1') {
        return axiosInstance.patch(this.buildVersionedEndpoint(endpoint, version), body, {
            params: queryParams
        });
    }

    static async putFormData(endpoint, body, queryParams = {}, version = 'v1') {
        const formData = FormHelper.generateFormData(body);

        return axiosInstance.put(
            this.buildVersionedEndpoint(endpoint, version),
            formData,
            {
                params: queryParams,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    static async delete(endpoint, queryParams = {}, version = 'v1') {
        return axiosInstance.delete(this.buildVersionedEndpoint(endpoint, version), {
            params: queryParams
        });
    }

    static async postFile(endpoint, file, headers = {}, version = 'v1') {
        return axiosInstance.post(this.buildVersionedEndpoint(endpoint, version), file, {
            params: {},
            headers: {
                'Content-Type': 'application/octet-stream',
                ...headers,
                'Content-Disposition': `attachment; filename="${file.name}"`,
                'x-file-name': file.name,
                'x-file-type': file.type,
                'x-file-size': file.size
            }
        });
    }
}

export default ApiClient;
